/** Save an API response locally using the browser's native download support. */
export default function download(data, fileName, mimeType) {
  const blob =
    data instanceof Blob
      ? data
      : new Blob([data], { type: mimeType || 'application/octet-stream' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName || 'download';
  anchor.hidden = true;
  document.body.appendChild(anchor);
  try {
    anchor.click();
  } finally {
    anchor.remove();
    // Allow the browser to start reading large response blobs before releasing them.
    setTimeout(() => URL.revokeObjectURL(url), 40000);
  }
}
